import React from "react";
import { useIntl } from "react-intl";

import TooltipButton from "../tooltipButton";

const SelectAllButton = ({ allSelected, onClick }) => {
  const intl = useIntl();
  return (
    <TooltipButton
      icon="select"
      onClick={onClick}
      className="header-button-margin"
      title={
        allSelected
          ? intl.formatMessage({
              id: "messages.deselectAll",
              defaultMessage: "Odznačit všechny záznamy",
            })
          : intl.formatMessage({
              id: "messages.selectAll",
              defaultMessage: "Označit všechny záznamy",
            })
      }
    />
  );
};

export default SelectAllButton;
